import { SVGProps } from 'react'
import { flattenNestedSvg } from 'utils/flattenNestedSvg'

type QrCodeIllustrationProps = SVGProps<SVGSVGElement> & {
	qrMarkup?: string
}

const QrCodeIllustration = ({
	qrMarkup,
	...props
}: QrCodeIllustrationProps) => {
	return (
		<svg
			viewBox="0 0 500 240"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0 12C0 5.373 5.373 0 12 0h476c6.627 0 12 5.373 12 12v228H0z"
				fill="#EAF1FF"
			/>
			<mask
				id="a"
				style={{
					maskType: 'alpha',
				}}
				maskUnits="userSpaceOnUse"
				x={0}
				y={0}
				width={500}
				height={240}
			>
				<path
					d="M0 10C0 4.477 4.477 0 10 0h480c5.523 0 10 4.477 10 10v230H0z"
					fill="#E7E8FB"
				/>
			</mask>
			<g mask="url(#a)">
				<path
					d="M32.292 273.382h412.364s41.973-96.991 9.995-105.155-42.63 60.063-42.63 60.063 28.763-130.296-33.909-121.422c-62.682 8.884-11.783 119.669-11.783 119.669s-37.35-133.911-135.061-115.353-82.693 91.849-82.693 91.849-40.329-99.653-92.287-78.892 63.339 89.331 63.339 89.331-62.671-19.584-70.663 3.74 60.751 31.336 60.751 31.336-29.441-.036-77.403 24.843z"
					fill="#DDE6F9"
				/>
				<mask
					id="b"
					style={{
						maskType: 'luminance',
					}}
					maskUnits="userSpaceOnUse"
					x={379}
					y={33}
					width={78}
					height={26}
				>
					<path d="M456.179 33.391h-77.012v25.142h77.012z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path
						d="M456.179 58.533h-77.012s10.546-23.586 21.828-25.06 16.678 17.526 16.678 17.526 7.276-6.716 12.999-6.716 10.137 8.844 10.137 8.844 11.446-6.06 15.37 5.406"
						fill="#fff"
					/>
				</g>
				<mask
					id="c"
					style={{
						maskType: 'luminance',
					}}
					maskUnits="userSpaceOnUse"
					x={62}
					y={66}
					width={55}
					height={19}
				>
					<path d="M116.837 66.783H62.5v17.739h54.337z" fill="#fff" />
				</mask>
				<g mask="url(#c)">
					<path
						d="M62.5 84.522h54.337s-7.441-16.642-15.401-17.681c-7.961-1.04-11.767 12.365-11.767 12.365s-5.134-4.739-9.172-4.739-7.152 6.241-7.152 6.241-8.077-4.275-10.845 3.814"
						fill="#fff"
					/>
				</g>
				<path
					d="M330.497 159.841c1.582 0 2.878-1.378 2.878-3.064V132.95c0-1.686-1.295-3.065-2.878-3.065h-.727V79.098c0-14.273-10.9-25.88-24.304-25.88H190.149c-13.404 0-24.304 11.607-24.304 25.88v50.801c-1.999.111-3.604 1.884-3.604 4.043v44.31c0 2.159 1.606 3.931 3.604 4.044v150.653c0 14.273 10.901 25.881 24.304 25.881h115.317c13.404 0 24.304-11.608 24.304-25.881V194.167h.727c1.582 0 2.878-1.38 2.878-3.064v-23.828c0-1.685-1.295-3.064-2.878-3.064h-.727v-4.369h.727zM171.529 79.098c0-10.934 8.352-19.827 18.62-19.827h115.317c10.268 0 18.619 8.893 18.619 19.827v253.85c0 10.934-8.351 19.827-18.619 19.827H190.149c-10.268 0-18.62-8.893-18.62-19.827z"
					fill="#9BA2FB"
				/>
				<path
					d="M324.392 79.097v253.851c0 10.933-8.351 19.827-18.62 19.827H190.456c-10.269 0-18.62-8.894-18.62-19.827V79.098c0-10.934 8.351-19.827 18.62-19.827h115.316c10.269 0 18.62 8.893 18.62 19.826"
					fill="#fff"
				/>
				<path
					d="M297.278 115.021h-99.377v99.899h99.377z"
					fill="#fff"
					opacity={0.9}
				/>
				<g transform="translate(204, 121)">
					{qrMarkup ? (
						<g
							dangerouslySetInnerHTML={{
								__html: flattenNestedSvg(qrMarkup, {
									x: 0,
									y: 0,
									width: 88,
									height: 88,
								}),
							}}
						/>
					) : (
						<rect width={88} height={88} fill="#DDE6F9" />
					)}
				</g>
				<path
					d="M194.406 131.311a1.316 1.316 0 0 1-1.312-1.32v-18.003c0-.729.587-1.322 1.312-1.322h18.072c.725 0 1.313.591 1.313 1.32s-.588 1.319-1.313 1.319h-16.757v16.684c0 .729-.587 1.32-1.313 1.32zm106.365.08c-.725 0-1.313-.59-1.313-1.319v-16.846h-16.597c-.725 0-1.312-.59-1.312-1.319s.587-1.319 1.312-1.319h17.91c.725 0 1.312.59 1.312 1.319v18.167c0 .729-.587 1.319-1.312 1.319zm0 90.476h-18.072c-.726 0-1.313-.59-1.313-1.319s.587-1.321 1.313-1.321h16.757v-16.685c0-.729.587-1.319 1.312-1.319s1.313.59 1.313 1.319v18.004c0 .729-.588 1.319-1.313 1.319zm-88.453.082h-17.912a1.316 1.316 0 0 1-1.312-1.32v-18.167c0-.729.587-1.319 1.312-1.319s1.313.59 1.313 1.319v16.846h16.597c.725 0 1.312.59 1.312 1.319s-.587 1.319-1.312 1.319zM225 71.43a5.69 5.69 0 0 1 5.692-5.691h38.616A5.69 5.69 0 0 1 275 71.431a6.83 6.83 0 0 1-6.83 6.83h-36.34a6.83 6.83 0 0 1-6.83-6.83"
					fill="#9BA2FB"
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M407.894 108.522c0 5.739 4.866 10.402 10.856 10.402v2.152c-5.982 0-10.856 4.663-10.856 10.402h-2.246c0-5.739-4.867-10.402-10.856-10.402v-2.152c5.989 0 10.856-4.663 10.856-10.402zm-46.322 100.174c0 3.13 2.751 5.673 6.136 5.673v1.174c-3.381 0-6.136 2.544-6.136 5.674h-1.269c0-3.13-2.751-5.674-6.136-5.674v-1.174c3.385 0 6.136-2.543 6.136-5.673zM63.85 164.87c0 4.174 3.598 7.565 8.025 7.565V174c-4.422 0-8.024 3.391-8.024 7.565h-1.66c0-4.174-3.597-7.565-8.025-7.565v-1.565c4.428 0 8.025-3.391 8.025-7.565z"
				fill="#fff"
			/>
		</svg>
	)
}
export default QrCodeIllustration
